"use strict";

import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { EaselPlugin } from "gsap/EaselPlugin";
// import {
//   CustomEase
// } from "gsap/CustomEase";
import { initializeSidenav } from "./_sideNav";
import Vivus from "vivus";
import { slideDown, slideUp } from "slide-anim";

document.querySelectorAll(".header-toggle").forEach((target) => {
  target.addEventListener("click", (e) => {
    const thisBtn = e.currentTarget;
    thisBtn.classList.toggle("is-open");
    document.querySelector(".header-nav").classList.toggle("is-open");
  });
});

setupAccordion();

function setupAccordion() {
  // トリガークラス'.js-accordion'を持つ要素を取得
  const accordionTrigger = document.querySelectorAll(".js-accordion");
  for (let i = 0; i < accordionTrigger.length; i++) {
    // トリガーを押した時のアクション
    let accordionTargetisOpened = false;
    accordionTrigger[i].addEventListener("click", (e) => {
      // クリックされた要素（トリガー要素）を取得
      let currentElement = e.currentTarget;
      let cmnBtn = currentElement.querySelector(".cmn-more-btn");
      // 同じ親要素を持つ隣接した次の要素'.js-accordion'（展開対象の要素）を取得
      let accordionTarget = currentElement.nextElementSibling;
      if (accordionTargetisOpened) {
        //トリガーの'is-active'クラスを削除
        currentElement.classList.remove("is-active");
        cmnBtn.classList.remove("is-open");
        slideUp(accordionTarget).then(function () {
          accordionTargetisOpened = false;
        });
      } else {
        //トリガーの'is-active'クラスを追加
        currentElement.classList.add("is-active");
        cmnBtn.classList.add("is-open");
        slideDown(accordionTarget).then(function () {
          accordionTargetisOpened = true;
        });
      }
    });
  }
}

/**
 * スクロールイベント登録
 */
window.addEventListener(
  "scroll",
  function () {
    toggleClassWithScroll(`.header`, `.header-trigger`, `is-view`);
  },
  false
);

window.addEventListener("DOMContentLoaded", () => {
  $("body").addClass("is-load");
  initializeSidenav();
});

/**
 * 指定した位置まで要素がスクロールした時に、classを追加する
 *
 * @param selector クラスを追加したい要素
 * @param className 追加したいクラス名
 */

function toggleClassWithScroll(target, selector, className) {
  let elements = document.querySelectorAll(selector);
  let targets = document.querySelectorAll(target);

  Array.prototype.forEach.call(elements, function (element, index) {
    // windowの高さ - a
    let windowHeight = window.document.documentElement.clientHeight;

    // 現在のスクロール量
    let scrollTop =
      document.documentElement.scrollTop || document.body.scrollTop;

    // 画面左上から要素までの高さ - b
    let rect = element.getBoundingClientRect();
    let offset = rect.top + scrollTop;

    // 要素が画面に表示されるスクロール量(a - b)
    let scrollHeight = offset - windowHeight;

    // 画面の1/4を超えたら、classを追加
    if (scrollTop > scrollHeight + windowHeight / 4) {
      targets.forEach((target) => {
        target.classList.add(className);
      });
    } else {
      targets.forEach((target) => {
        target.classList.remove(className);
      });
    }
  });
}

$(function () {
  $('a[href^="#"]').click(function () {
    var href = $(this).attr("href");
    var target = $(href == "#" || href == "" ? "html" : href);
    var headerHeight = $(".header").height() + $(".common-link").height() + 50;

    var position = target.offset().top - headerHeight;
    var speed = 500;
    $("html, body").animate(
      {
        scrollTop: position,
      },
      speed,
      "swing"
    );
    return false;
  });
});
$(function () {
  let url = location.href;
  if (url.indexOf("?id=") != -1) {
    let id = url.split("?id=");
    let $target = $("#" + id[id.length - 1]);
    let headerHeight = $(".header").height() + $(".common-link").height() + 50;
    if ($target.length) {
      let position = $target.offset().top - headerHeight;
      $("html, body").animate({ scrollTop: position }, 1);
    }
  }
});
